import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createBaseChartConfig, type ChartData } from './chartConfigUtils';
import ChartPlaceholder from './ChartPlaceholder';

interface DailyMetalContractCountData {
    date: string;
    count: number;
}

interface DailyMetalContractCountChartProps {
    data: DailyMetalContractCountData[];
    loading?: boolean;
    referenceValue?: number;
}

const DailyMetalContractCountChart: React.FC<DailyMetalContractCountChartProps> = ({
    data,
    loading = false,
    referenceValue,
}) => {
    const { t } = useTranslation();

    const chartData: ChartData[] = data.map(item => ({ date: item.date, value: item.count }));
    const options: Highcharts.Options = createBaseChartConfig(
        chartData,
        {
            chartType: 'column',
            yAxisTitle: t('statistics.charts.numberOfMetalContracts', 'Number of Metal Contracts'),
            yAxisColor: '#52c41a',
            seriesName: t('statistics.charts.metalContractCount', 'Metal Contract Count'),
            seriesColor: '#52c41a',
            referenceValue,
        },
        t,
    );

    // Show placeholder if loading or no data
    if (loading || !data || data.length === 0) {
        return <ChartPlaceholder loading={loading} hasData={!!data && data.length > 0} />;
    }

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default DailyMetalContractCountChart;
